"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackWrapper = void 0;

var React = _interopRequireWildcard(require("react"));

var _FeedbackModal = require("./internal/FeedbackModal");

var _environment = require("../environment");

var _reactComponents = require("@cimpress/react-components");

var _i18n = require("../locales/i18n");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const FeedbackWrapper = props => {
  const {
    accessToken,
    environment,
    children,
    language,
    campaignId,
    questionId,
    onTriggered,
    onSubmitted,
    onCancelled,
    sessionId
  } = props;
  const [showModal, setShowModal] = React.useState(false);
  const [showSnackbar, setShowSnackbar] = React.useState(false);
  const {
    tt
  } = (0, _i18n.useDoubleTTranslation)(props.language);

  const handleClick = () => {
    setShowSnackbar(false);
    setShowModal(true);

    if (onTriggered) {
      onTriggered();
    }
  };

  const handleCancelled = () => {
    setShowModal(false);

    if (onCancelled) {
      onCancelled();
    }
  };

  const handleSubmission = () => {
    setShowModal(false);
    setShowSnackbar(true);
  };

  const handleSubmitted = data => {
    if (onSubmitted) {
      onSubmitted(data);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_reactComponents.Snackbar, {
    show: showSnackbar,
    delay: 2000,
    onHideSnackbar: () => setShowSnackbar(false)
  }, tt('feedbackWrapper.thank_you_for_your_feedback')), /*#__PURE__*/React.createElement(_FeedbackModal.FeedbackModal, {
    accessToken: accessToken,
    environment: environment,
    language: language,
    show: showModal,
    onSubmitted: handleSubmitted,
    onSubmission: handleSubmission,
    onCancelled: handleCancelled,
    campaignId: campaignId,
    questionId: questionId,
    mixpanelIntegration: props.mixpanelIntegration,
    mixpanelEventNameOverride: props.mixpanelEventNameOverride,
    sessionId: sessionId
  }), /*#__PURE__*/React.createElement("span", {
    onClick: () => handleClick()
  }, children));
};

exports.FeedbackWrapper = FeedbackWrapper;
FeedbackWrapper.defaultProps = {
  language: 'en',
  environment: _environment.ProductionEnvironment
};